import React from 'react';

/**
 * Multi-line text input atom.
 */
export default function Textarea({
  value,
  onChange,
  placeholder,
  maxLength,
  rows = 4,
  className = '',
  ...props
}) {
  return (
    <textarea
      className={`ca-textarea ${className}`.trim()}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      maxLength={maxLength}
      rows={rows}
      {...props}
    />
  );
}
